import { Link } from "react-router";
import logoSBAWhite from "@assets/events-awards/logo-sba-white.svg";
import FooterMenuLinks from "@events-awards/components/EventsAwardsFooterComponents/FooterMenuLinks";
import { EVENTS_AWARDS_SBA_PATH } from "@events-awards/utils/constants";
import { SBA_FOOTER_MENU } from "@sba/utils/constants";

/**
 * Component to display footer for mobile view in SBA pages
 */
const SBAFooterMobile = (): React.ReactElement => {
  return (
    <div
      className="w-full pb-2 text-center"
      data-testid="sba-footer-mobile-component"
    >
      <div className="mb-12 flex w-full flex-col items-center justify-center">
        <Link to={EVENTS_AWARDS_SBA_PATH} reloadDocument>
          <img
            src={logoSBAWhite}
            alt="Singapore Business Awards logo"
            width={180}
            height={24.09}
          />
        </Link>
      </div>

      <div>
        <h3 className="mb-2 text-left font-public-sans text-base font-medium">
          About Us
        </h3>

        <p className="text-left text-base leading-[1.4] text-white">
          The Singapore Business Awards (SBA), launched in 1985, is jointly
          organised by The Business Times, and DHL. The objectives of the awards
          are to acknowledge the vital contributions made by companies and
          business leaders to Singapore&apos;s development and to encourage the
          entrepreneurial spirit in Singapore. The awards also give recognition
          to excellence in corporate management.
        </p>
      </div>

      <div className="-mx-0 mt-12 flex w-full flex-row">
        <div className="w-1/2">
          <h3 className="mb-4 text-left font-public-sans text-base font-semibold">
            Sections
          </h3>

          <FooterMenuLinks
            items={SBA_FOOTER_MENU.slice(0, 6)}
            className="space-y-4"
          />
        </div>

        <div className="w-1/2 pl-3">
          <h3 className="mb-4 text-left font-public-sans text-base font-semibold">
            Quick Links
          </h3>

          <FooterMenuLinks items={SBA_FOOTER_MENU.slice(6, 7)} />
        </div>
      </div>
    </div>
  );
};

export default SBAFooterMobile;
